export default "__VITE_ASSET__HV1sQSJH__"